import React, { Component } from 'react';
import Connect from '../../../components/Forms/Connect';
import logo from '../../../assets/logo.svg';
import paper from '../../../assets/paper-self-funded.png';

class WhitePaperSelfFunded extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - WhitePaper',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <article id='whitepapers'>
        <div id='banner'>
          <div className='wrap'>
            <div>
              <img src={logo} alt='CDPHP' className='logo' />
              <h1>Is a Self-Funded Health Plan Right For Your Business?</h1>
              <p>Explore the benefits of self-funding for organizations large or&nbsp;small.</p>
            </div>
            <img src={paper} alt='Paper' className='paper' />
          </div>
        </div>
        <section>
          <div className='wrap'>
            <main>
              <p>Self-funded health plans have long been favored by large employer groups for their flexibility and potential cost savings. Now, smaller businesses are increasingly exploring these options, too, thanks to customized plan designs and cost containment strategies.</p>
              <h3>Download this paper to learn:</h3>
              <ul>
                <li>The differences between self-funded and fully insured plans and their impact on your business&rsquo;s financial and operational strategies</li>
                <li>The role that group captives and modern Third-Party Administrators (TPAs) play in lowering the barriers to entry for smaller businesses (with 101+ employees)</li>
                <li>Key criteria for selecting the right TPA for your business, including essential questions to ask</li>
                <li>The benefits of focusing on proactive employee health through self-funding, and how that can reduce the total cost of care</li>
                <li>How CDPHP is reshaping the self-funded marketplace regionally with a focus on quality and affordability</li>
              </ul>
            </main>
            <aside>
              <Connect
                area='LargeGroupDownload'
                heading='Get the Paper'
                subheading={false}
                submitText='Download'
                gaEventLabel='Plans - Self Funded Paper Download Lead'
                type='paper'
                paperUrl='/pdf/CDPHP_Self-Funded_Health_Plans_Paper_2025.pdf'
                paperTitle='Is a Self-Funded Health Plan Right For Your Business?'
                displayInline />
            </aside>
          </div>
        </section>
      </article>
    );
  }
}

export default WhitePaperSelfFunded;